import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '../providers/nav.service';
import { Chart } from 'chart.js';
import { ApiService } from '../providers/api.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
// import { CommonService } from '../providers/common.service';
import { MLBBatterToolTip, pageFilters, SharedService ,platformList, sportList } from '../shared.service';
import { CommonService } from '../providers/common.service';
import {Subject} from 'rxjs';
import { element } from 'protractor';

@Component({
  selector: 'app-last5',
  templateUrl: './last5.component.html',
  styleUrls: ['./last5.component.css']
})
export class Last5Component implements OnInit, OnDestroy {

  initialGameStyleId = '';
  FiltersData: any = {};
  gameStyleList = [];
  categoryList = [];
  boardSinglePlayerList = [];
  selectedFilters: any = {
    sportId: '1',
    platformId: '1',
    slate: '',
    Position: '',
    salaryRange: '0, 100000.00',
    categoryName: 'fantasy_points',
    limit: this.sharedService.defaultLimit,
    player_type: 'pitching'
  };
  showChildComponent = false;
  loginUserDetails: any = JSON.parse(localStorage.getItem('userDetails'));
  profileDet: any = {};
  playerList: any = [];
  MLBBatterToolTip = new MLBBatterToolTip();

  tableType = sportList[sportList.NFL];
  dropdownChanged = false;
  // tempLast5 = [{
  //   player_name: 'JuJu Smith-Schuster',
  //   opposition: [
  //     {
  //       fantasy_points: 0,
  //       fivegmAVG: 0,
  //       player_id: 1918,
  //       player_name: 'Chris Moore',
  //       vs_prev_10gm_avg: 0
  //     },
  //     {
  //       fantasy_points: 0.1,
  //       fivegmAVG: 0.1,
  //       player_id: 2879,
  //       player_name: 'De\'Anthony Thomas',
  //       vs_prev_10gm_avg: 0
  //     },
  //     {
  //       fantasy_points: 1.1,
  //       fivegmAVG: 1.1,
  //       player_id: 1915,
  //       player_name: 'Jaleel Scott',
  //       vs_prev_10gm_avg: 0
  //     },
  //     {
  //       fantasy_points: 2.5,
  //       fivegmAVG: 6.025,
  //       player_id: 1867,
  //       player_name: 'Marquise Brown',
  //       vs_prev_10gm_avg: -3.5250000000000004
  //     }
  //     , {
  //       fantasy_points: 0,
  //       fivegmAVG: 3.075,
  //       player_id: 1889,
  //       player_name: 'Miles Boykin',
  //       vs_prev_10gm_avg: -3.075
  //     }]
  // },
  // {
  //   player_name: 'JuJu Smith-Schuster',
  //   opposition: [
  //     {
  //       fantasy_points: 2.2,
  //       fivegmAVG: 2.2,
  //       player_id: 2551,
  //       player_name: 'Cody Latimer',
  //       vs_prev_10gm_avg: 0
  //     },
  //     {
  //       fantasy_points: 0,
  //       fivegmAVG: 0,
  //       player_id: 1175,
  //       player_name: 'Da\'Mari Scott',
  //       vs_prev_10gm_avg: 0
  //     },
  //     {
  //       fantasy_points: 7,
  //       fivegmAVG: 10.45,
  //       player_id: 386,
  //       player_name: 'Darius Slayton',
  //       vs_prev_10gm_avg: -3.4499999999999993
  //     },
  //     {
  //       fantasy_points: 15.3,
  //       fivegmAVG: 9.533333333333333,
  //       player_id: 381,
  //       player_name: 'Golden Tate',
  //       vs_prev_10gm_avg: 5.7666666666666675
  //     }
  //     , {
  //       fantasy_points: 6.4,
  //       fivegmAVG: 6.866666666666667,
  //       player_id: 375,
  //       player_name: 'Sterling Shepard',
  //       vs_prev_10gm_avg: -0.4666666666666668
  //     }]
  // }];

  selectedPlayerForPopup: any = {};
  display = 'none';
  popupPlayerTeamList = [];
  popupTeamList = [];
  popupSelectedPlayerId: any = '';
  popupSelectedTeam: any = '';
  popupSelectedHA: any = 'h';
  PopupLast5Position = '';
  popupLast5SomeRange = [0, 100000.00];
  popupLast5SalaryRange = '0, 100000.00';
  popUpLast5playerList = [];
  popupLast5TxtQueryChanged: Subject<string> = new Subject<string>();

  popupTrendPlayerList: any = {};
  popupTrendfinalGraphData = {
    labels: [],
    datasets: []
  };
  popupTrendMyChart;

  isSideFilterShow = true;
  defualtPopupTab = 'Trends';
  playerStatus = '';
  showPlayerStatus = false;

  playerGameLogList = [];
  resetFilters = null;
  sportList = sportList;

  constructor(
    private route: Router,
    private api: ApiService,
    private changeDetectorRef: ChangeDetectorRef,
    private SpinnerService: NgxSpinnerService,
    private commonService: CommonService,
    private toastr: ToastrService,
    private navService: NavService,
    public sharedService: SharedService,
  ) {

    this.showPlayerStatus = !this.loginUserDetails.isLogin;
    if (this.loginUserDetails && this.loginUserDetails.userDetails) {
      this.profileDet = this.loginUserDetails.userDetails;
    }
    if (this.loginUserDetails && this.loginUserDetails.currentSport_id) {
      this.commonService.platformandsport.sport_id = this.loginUserDetails.currentSport_id;
    }
    if (this.loginUserDetails && this.loginUserDetails.currentPlatform_id) {
      this.commonService.platformandsport.platform_id = this.loginUserDetails.currentPlatform_id;
    }
    this.selectedFilters.platformId = this.commonService.platformandsport.platform_id.toString();
    this.selectedFilters.sportId = this.commonService.platformandsport.sport_id.toString();
  }

  ngOnInit() {
    // var data = {
    //   labels: ['12/11', '12/8', '12/6', '12/4', '12/3', '12/1', '11/29', '11/27', '11/25', '11/23'],
    //   datasets: [{
    //     label: 'L. Dončić',
    //     fill: false,
    //     lineTension: '0',
    //     borderWidth: '2',
    //     backgroundColor: 'rgba(255,126,0)',
    //     borderColor: 'rgba(255,126,0)',
    //     pointBackgroundColor: 'rgba(255,126,0)',
    //     pointBorderColor: 'rgba(0,0,0)',
    //     pointBorderWidth: '1',
    //     data: [
    //       30.1, 25.5, 31.6, 32.5, 26.2, 35.2, 40.5, 21.3, 37.6, 35.2
    //     ]
    //   }, {
    //     label: 'N. Jokić',
    //     fill: false,
    //     lineTension: '0',
    //     borderWidth: '2',
    //     backgroundColor: 'rgba(0,100,246)',
    //     borderColor: 'rgba(0,100,246)',
    //     pointBackgroundColor: 'rgba(0,100,246)',
    //     pointBorderColor: 'rgba(0,0,0)',
    //     pointBorderWidth: '1',
    //     data: [
    //       37.6, 39.5, 35.8, 33.5, 28.3, 32.4, 38.1, 32.0, 39.4, 35.1
    //     ],
    //   }, {
    //     label: 'All Players',
    //     fill: false,
    //     lineTension: '0',
    //     borderWidth: '2',
    //     backgroundColor: 'rgba(209,0,222)',
    //     borderColor: 'rgba(209,0,222)',
    //     pointBackgroundColor: 'rgba(209,0,222)',
    //     pointBorderColor: 'rgba(0,0,0)',
    //     pointBorderWidth: '1',
    //     data: [
    //       40.6, 23.0, 24.7, 31.7, 29.7, 30.3, 21.3, 30.0, 34.8, 32.5
    //     ],
    //   }]
    // };


    // var ctx = document.getElementById('myChart');
    // var myChart = new Chart(ctx, {
    //   type: 'line',
    //   data: data,
    //   options: {
    //     responsive: true,
    //     title: {
    //       display: false
    //     },
    //     tooltips: {
    //       mode: 'index',
    //       intersect: false,
    //     },
    //     hover: {
    //       mode: 'nearest',
    //       intersect: true
    //     },
    //     scales: {
    //       xAxes: [{
    //         display: true,
    //         scaleLabel: {
    //           display: false,
    //           labelString: 'Games'
    //         }
    //       }],
    //       yAxes: [{
    //         display: true,
    //         scaleLabel: {
    //           display: false,
    //           labelString: 'Usage %'
    //         }
    //       }]
    //     }
    //   }
    // });

    this.defualtFilters();

  }

  defualtFilters() {
    const filtersObj = {
      platform_id: this.selectedFilters.platformId,
      sport_id: this.selectedFilters.sportId,
      user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
    };
    this.SpinnerService.show();
    this.api.boardInitialLoadData(filtersObj).subscribe(data => {
      this.SpinnerService.hide();
      if (data && data.code) {
        this.gameStyleList = data.data.gameStyleList;
        this.FiltersData = data.data;
        this.categoryList = data.data.categoryList;

        if(this.loginUserDetails.fieldType !== undefined){
          this.selectedFilters.player_type =  this.loginUserDetails.fieldType;
        }else{
          this.selectedFilters.player_type = this.selectedFilters.player_type ? this.selectedFilters.player_type : 'pitching';
        }
        this.selectedFilters.slate = '';
        this.initialGameStyleId = '';

        if (this.FiltersData && this.FiltersData.gameStyleList && this.FiltersData.gameStyleList.length > 0) {
          const classicObj = this.FiltersData.gameStyleList.find(x => (x.game_style_name.toLowerCase() == 'classic' || x.game_style_name.toLowerCase() == 'full roster'));
          this.initialGameStyleId = classicObj ? classicObj.game_style_id : this.FiltersData.gameStyleList[0].game_style_id;

          // this.FiltersData.gameStyleList.forEach(element => {
          //   if (this.initialGameStyleId == element.game_style_id && element.slates && element.slates.length > 0) {
          //     this.selectedFilters.slate = element.slates[0].slates_id;
          //   }
          // });

         // this.selectedFilters.slate = this.FiltersData.gameStyleList.filter(element => this.initialGameStyleId == element.game_style_id && element.slates && element.slates.length > 0)[0].slates[0].slates_id;

          let data = this.FiltersData.gameStyleList.filter(element => this.initialGameStyleId == element.game_style_id && element.slates && element.slates.length > 0);
          if (data.length > 0) {
            if (this.commonService.platformandsport.platform_id == platformList.DraftKings) {
              const blankSlates = data[0].slates.filter(({slates_label}) => slates_label === "" || slates_label === null);
              const withoutBlankSlates = data[0].slates.filter(({slates_label}) => slates_label !== "" && slates_label !== null);
              this.selectedFilters.slate = [...blankSlates, ...withoutBlankSlates][0].slates_id;

            }
            if (this.commonService.platformandsport.platform_id == platformList.FanDuel) {
              const blankSlates = data[0].slates.filter(({slates_label}) => slates_label === "Main" || slates_label === null);
              const withoutBlankSlates = data[0].slates.filter(({slates_label}) => slates_label !== "Main" && slates_label !== null);
              this.selectedFilters.slate = [...blankSlates, ...withoutBlankSlates][0].slates_id;
            }

            // if (type == 'DefaultSelectedSlate') {
            // this.filters.slate = this.slate[0].slates_id;
            // }
          }
          /*OVERWRITE LOCAL STORAGE SLATES*/
          if (localStorage.getItem('uselocalStorage') && localStorage.getItem('uselocalStorage') == 'yes') {
            this.selectedFilters.slate = JSON.parse(localStorage.getItem('userDetails')).slateSelection ? JSON.parse(localStorage.getItem('userDetails')).slateSelection.slate : this.FiltersData.gameStyleList.filter(element => this.initialGameStyleId == element.game_style_id && element.slates && element.slates.length > 0)[0].slates[0].slates_id;
          }
          localStorage.setItem('uselocalStorage', 'yes');
        }

        this.showChild();
        this.lastfive();

      } else {
        // console.log('Board Intital api ' + data.message);
      }
    }, (err) => {
      this.SpinnerService.hide();
      // console.log('Somthing went wrong');
    });
  }
  setSingleMLBColor(item) {
    item.data.listPlayer.forEach(element => {
      if (this.selectedFilters.player_type == 'batting') {
        element.category.avg.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.avg['gm' + this.selectedFilters.limit], key: 'element.category.avg.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.obp.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.obp['gm' + this.selectedFilters.limit], key: 'element.category.obp.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.slg.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.slg['gm' + this.selectedFilters.limit], key: 'element.category.slg.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.ops.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ops['gm' + this.selectedFilters.limit], key: 'element.category.ops.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.iso.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.iso['gm' + this.selectedFilters.limit], key: 'element.category.iso.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.babip.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.babip['gm' + this.selectedFilters.limit], key: 'element.category.babip.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.ct.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ct['gm' + this.selectedFilters.limit], key: 'element.category.ct.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.rc.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rc['gm' + this.selectedFilters.limit], key: 'element.category.rc.gm' + this.selectedFilters.limit, sport: 'MLB', type: 'rank', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false, 'rank'));
        element.category.bbk.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.bbk['gm' + this.selectedFilters.limit], key: 'element.category.bbk.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.walk.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.walk['gm' + this.selectedFilters.limit], key: 'element.category.walk.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
      }



      /*pitching category*/
      if (this.selectedFilters.player_type == 'pitching') {
        element.category.ip.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ip['gm' + this.selectedFilters.limit], key: 'element.category.ip.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.so.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.so['gm' + this.selectedFilters.limit], key: 'element.category.so.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.era.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.era['gm' + this.selectedFilters.limit], key: 'element.category.era.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.whip.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.whip['gm' + this.selectedFilters.limit], key: 'element.category.whip.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.fip.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fip['gm' + this.selectedFilters.limit], key: 'element.category.fip.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.k9.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.k9['gm' + this.selectedFilters.limit], key: 'element.category.k9.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.bb9.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.bb9['gm' + this.selectedFilters.limit], key: 'element.category.bb9.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.kbb.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.kbb['gm' + this.selectedFilters.limit], key: 'element.category.kbb.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.hr9.gm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.hr9['gm' + this.selectedFilters.limit], key: 'element.category.hr9.gm' + this.selectedFilters.limit, sport: 'MLB', player_type: this.selectedFilters.player_type }, this.getColorReverseCondition(false));
      }
    });
  }
  getColorReverseCondition(d, type = null) {
    if (this.selectedFilters.typedisplay != 1 && type == null && type != 'rank') {
      // return !d;
    }
    return d;
  }

  showChild() {
    if (this.showChildComponent) {
      this.showChildComponent = false;
    }
    this.changeDetectorRef.detectChanges();

    this.showChildComponent = true;
  }

  lastfive() {
     this.selectedFilters.categoryName = (this.selectedFilters.sportId == 2 && this.selectedFilters.categoryName) ? this.selectedFilters.categoryName : 'fantasy_points';
     const lastPlayersFiltersData = {
      user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
      sport_id: this.selectedFilters.sportId,
      platform_id: this.selectedFilters.platformId,
      slates_id: this.selectedFilters.slate.toString(),
      position: (this.selectedFilters.Position == null) || (this.selectedFilters.Position == 'All Positions') ? '' : this.selectedFilters.Position,
      salary_range: this.dropdownChanged ? '0, 100000.00' : this.selectedFilters.salaryRange,  // testing
      category_name: this.selectedFilters.categoryName ? this.selectedFilters.categoryName : 'fantasy_points', // this is extra value for getting api response
      player_type: this.selectedFilters.player_type ? this.selectedFilters.player_type : ''
    };
     this.SpinnerService.show();
     this.api.last5PlayerList(lastPlayersFiltersData).subscribe(item => {
      this.SpinnerService.hide();
      this.dropdownChanged = false;
      if (item && item.code == 100) {

        this.playerList = item.data.listPlayer;
        item.data.gameStyleList = this.gameStyleList;
        this.FiltersData = item.data;
        this.FiltersData.positionList = [{position_id:"",position_name:"All Positions"}].concat(this.FiltersData.positionList);

      } else {
        this.playerList = [];
      }
    }, (err) => {
      this.SpinnerService.hide();
      this.playerList = [];
      // console.log('something went wrong');
    });
  }

  onSeeMore() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
    this.route.navigate(['/Trends']);
  }

  getPlatformandSport(data) {
    // console.log(data);
    this.selectedFilters.platformId = data.platformId;
    this.selectedFilters.sportId = data.sportId;
    if(data.sportId != 3)
      this.selectedFilters.player_type = "pitching";
    this.defualtFilters();
  }

  getGameandSlate(data) {
    // console.log(data);
    this.dropdownChanged = true;
    this.selectedFilters.gameStyle = data.gameStyle;
    this.selectedFilters.slate = data.slate;
    console.log(this.selectedFilters)
    this.resetFilters = null;
    this.lastfive();
    this.resetFilters = pageFilters.last5;
  }

  getSideBarFilteredData(data) {
    // console.log(data);
    this.selectedFilters.Position = data.Position;
    this.selectedFilters.categoryName = data.categoryName;
    this.selectedFilters.player_type = data.player_type;
    this.selectedFilters.salaryRange = data.salaryRange;
    this.lastfive();
  }

  getFilteredData(item) {
    // console.log(item);
  }

  ngOnDestroy() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
  }

  closeModalDialog() {
    this.display = 'none';
  }
  gmColor(value, sportId = 1 , categoryName = 'fantasy_points') {
    return this.sharedService.getLast5ColorCode(value, sportId, categoryName);
  }
  // PlayersTeamList() {
  //   const item = {
  //     platform_id: this.selectedFilters.platformId.toString(),
  //     sport_id: this.selectedFilters.sportId.toString(),
  //     slates_id: this.selectedFilters.slate.toString()
  //   }
  //   this.SpinnerService.show();
  //   this.api.playerTeamList(item).subscribe(data => {
  //     this.SpinnerService.hide();
  //     if (data && data.code == 100) {
  //       this.popupPlayerTeamList = data.data.playerTeamList;

  //       this.popupPlayerTeamList = this.popupPlayerTeamList.filter(function (el) {
  //         return el.opp != null;
  //       });

  //       this.popupPlayerTeamList.forEach(element => {
  //         if (element.player_id == this.popupSelectedPlayerId) {
  //           this.popupTeamList = element.opp.split(',');
  //         }
  //       });

  //       // this.popupTeamList = this.popupPlayerTeamList[0].opp.split(',');

  //       // this.popupSelectedPlayerId = this.popupPlayerTeamList[0].player_id;
  //       this.popupSelectedTeam = this.popupTeamList[0];
  //       this.popupSelectedHA = 'h';

  //     } else {
  //       this.popupSelectedPlayerId = '';
  //       this.popupSelectedTeam = '';
  //       this.popupSelectedHA = 'h';
  //       this.popupTeamList = [];
  //     }

  //     // this.trendPlayerList();
  //   }, (err) => {
  //     if (this.popupTrendMyChart) {
  //       this.popupTrendMyChart.chart.clear();
  //       this.popupTrendMyChart.chart.destroy();
  //       this.popupTrendMyChart.destroy();
  //     }
  //     this.SpinnerService.hide();
  //     console.log('Somthing went wrong');
  //   });
  // }

  // trendPlayerList() {
  //   const players = {
  //     players: [
  //       { player_id: this.popupSelectedPlayerId, opp: this.popupSelectedTeam, ha: this.popupSelectedHA }]
  //   }
  //   const trendsPlayersFiltersData = {
  //     sport_id: this.selectedFilters.sportId,
  //     platform_id: this.selectedFilters.platformId,
  //     category_name: 'fantasy_points',
  //     record_type: 'game',
  //     limit: '5',
  //     players: JSON.stringify(players)
  //   }
  //   this.SpinnerService.show();
  //   this.api.trendsPlayerList(trendsPlayersFiltersData).subscribe(item => {
  //     this.SpinnerService.hide();
  //     if (item && item.code == 100) {
  //       this.popupTrendPlayerList = item.data;
  //     } else {
  //       this.popupTrendPlayerList = { data: [], labelList: [] };
  //     }

  //     this.graphView();
  //   }, (err) => {
  //     this.SpinnerService.hide();
  //     this.popupTrendPlayerList = { data: [], labelList: [] };
  //     this.graphView();
  //     console.log('something went wrong');
  //   });
  // }

  graphView() {
    this.popupTrendfinalGraphData = {
      labels: [],
      datasets: []
    };
    if (this.popupTrendPlayerList && this.popupTrendPlayerList.labelList.length > 0) {
      let count = 1;
      this.popupTrendPlayerList.data.forEach(element => {
        let tempvalue = {};
        if (element != null) {
          let lineColor = 'rgba(255,126,0)';
          if (count == 2) {
            lineColor = 'rgba(0,100,246)';
          } else if (count == 3) {
            lineColor = 'rgba(209,0,222)';
          } else if (count == 4) {
            lineColor = 'rgba(51,204,102)';
          } else if (count == 5) {
            lineColor = 'rgba(255,0,51)';
          }

          tempvalue = {
            label: element.player_name,
            opp_title: element.opp_title,
            category: element.category,
            dates: element.dates,
            fill: false,
            lineTension: '0',
            borderWidth: '2',
            backgroundColor: lineColor,
            borderColor: lineColor,
            pointBackgroundColor: lineColor,
            pointBorderColor: 'rgba(0,0,0)',
            pointBorderWidth: '1',
            data: element.points
          };
          count++;
        } else {
          tempvalue = null;
          this.popupTrendfinalGraphData.labels.push(null);
        }

        this.popupTrendfinalGraphData.labels = this.popupTrendPlayerList.labelList;
        // this.popupTrendfinalGraphData.labels = element.dates;
        this.popupTrendfinalGraphData.datasets.push(tempvalue);
      });
    } else {
      this.popupTrendfinalGraphData = null;
    }

    if (this.popupTrendMyChart) {
      this.popupTrendMyChart.chart.clear();
      this.popupTrendMyChart.chart.destroy();
      this.popupTrendMyChart.destroy();
    }

    if (this.popupTrendfinalGraphData && this.popupTrendfinalGraphData.datasets) {
      this.popupTrendfinalGraphData.datasets = this.popupTrendfinalGraphData.datasets.filter((el) => {
        return el != null;
      });
    }

    if (this.popupTrendfinalGraphData && this.popupTrendfinalGraphData.labels) {
      this.popupTrendfinalGraphData.labels = this.popupTrendfinalGraphData.labels.filter((el) => {
        return el != null;
      });
    }

    const ctx = document.getElementById('myChart');
    this.popupTrendMyChart = new Chart(ctx, {
      type: 'line',
      data: this.popupTrendfinalGraphData,
      options: {
        responsive: true,
        title: {
          display: false
        },
        tooltips: {
          hideDelay: 0,
          callbacks: {
            title(tooltipItem, data) {
              return data.datasets[tooltipItem[0].datasetIndex].label;
            },
            label(tooltipItem, data) {
              const label = [];
              label.push('Date : ' + data.datasets[tooltipItem.datasetIndex].dates[tooltipItem.index]);
              label.push('Opponent : ' + data.datasets[tooltipItem.datasetIndex].opp_titles[tooltipItem.index]);
              label.push(data.datasets[tooltipItem.datasetIndex].category + ' : ' + Math.round(tooltipItem.yLabel * 100) / 100);

              return label;
            }
          }
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'Games'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'Usage %'
            }
          }]
        }
      }
    });

    this.popupTrendMyChart.render();
  }


  // onPopupPlayerChangeEvent(event) {
  //   this.popupTeamList = [];
  //   this.popupPlayerTeamList.forEach(element => {
  //     if (element.player_id == this.popupSelectedPlayerId) {
  //       this.popupTeamList = element.opp.split(',');
  //     }
  //   });
  //   if (this.popupTeamList && this.popupTeamList.length > 0) {
  //     this.popupSelectedTeam = this.popupTeamList[0];
  //   }

  //   this.trendPlayerList();
  // }

  // onPopupTeamChangeEvent(event) {
  //   this.trendPlayerList();
  // }

  // popupChangeHa(event) {
  //   console.log(event.target.value);
  //   // this.popupSelectedHA = event.target.value;
  //   this.trendPlayerList();
  // }

  onPopupTabs(type, index) {
    this.defualtPopupTab = type;
    if (index == 1) {
      this.getPlayerGameLog();
      this.onTrendsPopup();
    } else if (index == 2) {
      this.PopupLast5Position = '';
      this.popupLast5SalaryRange = '0, 100000.00';
      this.popupLast5SomeRange = [0, 100000.00];
      this.popUpLast5playerList = [];
      this.onLast5Popup();
    } else if (index == 3) {
      this.onTrendsPopup();
    }
  }

  getPlayerGameLog() {
    const tmpData = {
      user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
      platform_id: this.selectedFilters.platformId,
      sport_id: this.selectedFilters.sportId,
      player_id: String(this.selectedPlayerForPopup.player_id),
      player_type:this.selectedFilters.player_type,
    };
    this.SpinnerService.show();
    this.playerGameLogList = [];
    this.api.getPlayerGameLog(tmpData).subscribe(item => {
      this.SpinnerService.hide();
      if (item && item.code == 100) {
        if (item.data && item.data.gameLog) {
          this.playerGameLogList = item.data.gameLog;
        }
      }
    });
  }

  // onPlayer(item) {
  //   console.log(item);
  //   this.display = 'block';
  //   this.selectedPlayerForPopup = item;
  //   this.popupSelectedPlayerId = this.selectedPlayerForPopup.player_id;
  //   this.PlayersTeamList();
  // }

  onPlayer(item) {
    if (this.selectedFilters.sportId == sportList.NFL) {
      this.tableType = sportList[sportList.NFL];
    } else if (this.selectedFilters.sportId == sportList.NBA) {
      this.tableType = sportList[sportList.NBA];
    } else if (this.selectedFilters.sportId == sportList.MLB) {
      this.tableType = sportList[sportList.MLB];
    }
    this.defualtPopupTab = 'Trends';
    if (item.status) {
      this.playerStatus = item.status;
    }
    this.selectedPlayerForPopup = item;
    this.getPlayerGameLog();
    this.onTrendsPopup();
    // this.PlayersTeamList();
  }

  addRemovePlayer(item) {
    const player = {
      player_id: item.player_id,
      slates_id: this.selectedFilters.slate,
    };

    if (item && item.is_manager) {
      this.sharedService.addPlayerForManager(player).then(res => {
        item.is_manager = res;
      });
    } else {
      this.sharedService.onRemovePlayer(player).then(res => {
        item.is_manager = res;
      });
    }
  }
  onTrendsPopup() {

    const players = {
      players: [
        {player_id: this.selectedPlayerForPopup.player_id, opp: '', ha: ''}]
    };
    const trendsPlayersFiltersData = {
      sport_id: this.selectedFilters.sportId,
      platform_id: this.selectedFilters.platformId,
      category_name: this.selectedFilters.categoryName,
      record_type: 'game',
      limit: this.selectedFilters.limit,
      players: JSON.stringify(players),
      player_type: this.selectedFilters.player_type,
    };
    this.SpinnerService.show();
    this.api.trendsPlayerList(trendsPlayersFiltersData).subscribe(item => {
      this.SpinnerService.hide();
      if (item && item.code == 100) {
        this.popupTrendPlayerList = item.data;
      } else {
        this.popupTrendPlayerList = {data: [], labelList: []};
      }
      this.graphView();
    }, (err) => {
      this.SpinnerService.hide();
      this.popupTrendPlayerList = {data: [], labelList: []};
      this.graphView();
      // console.log('something went wrong');
    });

    /*get single player details api*/
    const boardSinglePlayerFiltersData = {
      user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
      sport_id: this.selectedFilters.sportId,
      slates_id: this.selectedFilters['slate'].toString(),
      salary_range: '0, 100000.00',
      platform_id: this.selectedFilters.platformId,
      player_type: this.selectedFilters.player_type ? this.selectedFilters.player_type : '',
      trends_players: JSON.stringify(players),
      trends_limit: this.selectedFilters.limit
    };
    if (this.tableType == sportList[sportList.MLB]) {
      this.api.playerList(boardSinglePlayerFiltersData).subscribe(item => {
        if (item && item.code == 100) {
          if (item.data.listPlayer && item.data.listPlayer.length > 0) {
            this.setSingleMLBColor(item);
            this.boardSinglePlayerList = item.data.listPlayer;
          }

        }
      }, (err) => {
        this.SpinnerService.hide();
      });
    }
  }

  onSeeMoreTrend() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
    this.route.navigate(['/Trends']);
  }

  userToSignup() {
    if (!this.loginUserDetails.isLogin) {
      this.sharedService.userToSignup();
    }
  }

  onSeeMoreLast5() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
    this.route.navigate(['/Last5']);
  }

  changeCategory(event) {
    this.selectedFilters.categoryName = event.target.value;
    this.onLast5Popup();
  }


  onLast5Popup() {

    const lastPlayersFiltersData = {
      user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
      sport_id: this.selectedFilters.sportId,
      platform_id: this.selectedFilters.platformId,
      slates_id: this.selectedFilters.slate.toString(),
      // position: this.PopupLast5Position,
      // salary_range: this.popupLast5SalaryRange,
      player_type: this.selectedFilters.player_type ? this.selectedFilters.player_type : '',
      player_id: this.selectedPlayerForPopup.player_id,
      category_name: this.selectedFilters.categoryName ? this.selectedFilters.categoryName : 'fantasy_points' // this is extra value for getting api response
    };
    this.SpinnerService.show();
    this.api.last5PlayerList(lastPlayersFiltersData).subscribe(item => {
      this.SpinnerService.hide();
      if (item && item.code == 100) {

        this.popUpLast5playerList = item.data.listPlayer;
      } else {
        this.popUpLast5playerList = [];
      }
    }, (err) => {
      this.SpinnerService.hide();
      this.popUpLast5playerList = [];
      // console.log('something went wrong');
    });
  }



}
